module.exports = __webpack_public_path__ + "static/media/go-big-go-home-promo-slide.6982af4f.jpg";